
document.addEventListener("DOMContentLoaded", function(){
    adaptSubscripedSelector();
    updateSubscripedProduct();
    downgradeSubscribedProduct();
    changeSellingPlanOfSubscribedProduct();
    document.addEventListener('rerender_cart_event', ()=>{
      // console.log("rerender cart event from cart_subscription");
      adaptSubscripedSelector();
      updateSubscripedProduct();
      downgradeSubscribedProduct();
      changeSellingPlanOfSubscribedProduct();
    });

    var myInterval;

    function adaptSubscripedSelector(){
      let selectSubscribed = document.querySelectorAll('.selectSubscribed');
      let drawerContainer = document.querySelector("#sidebar-cart .Drawer__Main");

      // console.log("selectSubscribed: ",selectSubscribed);
      selectSubscribed.forEach(element => {
        element.addEventListener('click', function(){
          let sellingPlanParent = element.closest('.sellingPlan');
          let OptionSubscribed = sellingPlanParent.querySelector('.optionsSubscribed');
          // console.log("sellingPlanParent: ",sellingPlanParent, "OptionSubscribed: ",OptionSubscribed);
          // console.log("element clicked is ", element);
          // console.log("OptionSubscribed.classList.contains('hidden'): ",OptionSubscribed.classList.contains('hidden'));
          if(OptionSubscribed.classList.contains('hidden')){
            // console.log("show Options");
            HideAllSelectedOptions();
            clearInterval(myInterval);
            OptionSubscribed.classList.remove('hidden');
            if(drawerContainer){
              calculateCSSVariables(sellingPlanParent,drawerContainer,OptionSubscribed);
              myInterval = setInterval(function(){
                calculateCSSVariables(sellingPlanParent,drawerContainer,OptionSubscribed);
              }, 500);

            }
          }
          else{
            // console.log("hide Options");
            HideAllSelectedOptions();
            clearInterval(myInterval);
          }
        });
      });
      document.body.addEventListener("click", function (evt) {
          if(!evt.target.classList.contains('notTracked')){
              // console.log("not select subscribed so close all options");
              HideAllSelectedOptions();
              clearInterval(myInterval);
          }
      });
      if(drawerContainer){
        document.querySelector("#sidebar-cart .Drawer__Main").addEventListener('scroll', function(e) {
          console.log("scrolling drawer hide all options");
          HideAllSelectedOptions();
          clearInterval(myInterval);
        });

      }

    }

    function calculateCSSVariables(sellingPlanParent,drawerContainer,OptionSubscribed){
      var rectCalc = Math.abs(sellingPlanParent.offsetHeight + sellingPlanParent.getBoundingClientRect().top);
      var drawerMain = Math.abs(drawerContainer.offsetHeight + drawerContainer.getBoundingClientRect().top);
      if(rectCalc > drawerMain){
        rectCalc = drawerMain;
      }
      // console.log('drawerMain:',drawerMain);
      // console.log('rectCalc:',rectCalc);
      document.documentElement.style.setProperty('--drawer-offset-height', rectCalc + 'px');
      drawerContainer.classList.add('custom_height_class');
      OptionSubscribed.style.width = sellingPlanParent.clientWidth + 'px';
    }
    function HideAllSelectedOptions(){
      let optionsSubscribedDivs = document.querySelectorAll('.optionsSubscribed');
      let drawerContainer = document.querySelector("#sidebar-cart .Drawer__Main .Drawer__Container");
      optionsSubscribedDivs.forEach(element => {
        // console.log("hide optionsSubscribedDivs: ",element);
        element.classList.add('hidden');
        if(drawerContainer){
          document.querySelector("#sidebar-cart .Drawer__Main").classList.remove('custom_height_class');
          clearInterval(myInterval);
        }
      });
    }

    function addSubscribedItemToCart(variant_id, qty, selling_plan, pfandObject=null) {
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      // console.log("addSubscribedItemToCart",variant_id," qty: ", qty, "selling_plan:", selling_plan);
      let formData = {items:[]};
      if(selling_plan){
        formData.items.push({
          'id': variant_id,
          'quantity': qty,
          'selling_plan': selling_plan
        });
      }else{
        formData.items.push({
          'id': variant_id,
          'quantity': qty
        });
      }

      if(pfandObject){
        var pfand_key = pfandObject.qty_multi + "-" + Math.random().toString(16).slice(2);
        formData.items[0]['properties']={_pfand_key: pfand_key};
        if(pfandObject.selling_plan){
          formData.items[0]['properties']._pfand_selling_info =  pfandObject.id+":"+pfandObject.selling_plan;
          formData.items.unshift({
            'id': pfandObject.id,
            'quantity': pfandObject.quantity,
            'selling_plan': pfandObject.selling_plan,
            "properties":{_pfand_key:pfand_key}
          });
        }else{
          formData.items[0]['properties']._pfand_selling_info =  pfandObject.id;
          formData.items.unshift({
            'id': pfandObject.id,
            'quantity': pfandObject.quantity,
            "properties":{_pfand_key:pfand_key}
          });
        }
      }

      // console.log("formData: ",formData);
      fetch(window.routes.cartUrl + '/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
          document.dispatchEvent(new CustomEvent('theme:loading:end'));  
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }

    function removeItemFromCart2(line_item_order, subscriped_variantID, subscriped_qty, subscriped_sellingID){
      let formData = {
          'id': (line_item_order),
          'quantity': 0
      };
      let info = fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          },
          body: JSON.stringify(formData)
      }).then(response => response.json()).then(data => {
          addSubscribedItemToCart(subscriped_variantID,subscriped_qty,subscriped_sellingID);
          return data;
      }).catch((error) => {
          console.error('Error:', error);
      });
    }

    function removeItemFromCartWithPFD(removeItems, subscriped_variantID, subscriped_qty, subscriped_sellingID, pfndObject){

      let info = fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          },
          body: JSON.stringify({updates:removeItems})
      }).then(response => response.json()).then(data => {
          addSubscribedItemToCart(subscriped_variantID,subscriped_qty,subscriped_sellingID, pfndObject);
          return data;
      }).catch((error) => {
          console.error('Error:', error);
      });
    }


    function updateSubscripedProduct(){
      let upgradeButton = document.querySelectorAll(".upgradeButton");
      upgradeButton.forEach(element => {
        element.addEventListener('click', function(){
          element.closest('.upgradeDiv').classList.add('up_downGrade');
          element.classList.add('up_downGrade');
          element.textContent = "Upgrading...";

          //check pfand 
          let elementWrapper = element.closest('.CartItem');
          if(!elementWrapper)
            elementWrapper = element.closest('.CartItemWrapper');
          if(!elementWrapper && element.getAttribute('pfand-key'))
            elementWrapper = element;
          if(elementWrapper.getAttribute('pfand-key')){
            let correspondingPfand = document.querySelector('.pfand-item[pfand-key="'+elementWrapper.getAttribute('pfand-key')+'"]');
            if(correspondingPfand){
              MainSubscribedFunctionalityWithPFD(element, correspondingPfand.querySelector('.upgradeButton'));
            }
          }else{
            MainSubscribedFunctionality(element);
          }
        });
      });
    }

    function downgradeSubscribedProduct(){
      let downgrade = document.querySelectorAll(".downgrade");
      // console.log("downgrade: ",downgrade);
      downgrade.forEach(element => {
        element.addEventListener('click', function(){
          let subscripedParentDiv = element.closest('.newSubscribedEdits');
          // console.log("element: ",element);
          if(subscripedParentDiv == null){
            subscripedParentDiv = element.closest('.CartItem__Info');
          }
          // console.log("subscripedParentDiv: ",subscripedParentDiv);
          let selectSubscribed = subscripedParentDiv.querySelector('.selectSubscribed');
          let sellingPlanItem = subscripedParentDiv.querySelector('.sellingPlan');
          HideAllSelectedOptions();
          sellingPlanItem.classList.add('up_downGrade');
          selectSubscribed.classList.add('up_downGrade');
          selectSubscribed.innerHTML = "Downgrading...";

          //check pfand 
          let elementWrapper = element.closest('.CartItem');
          if(!elementWrapper)
            elementWrapper = element.closest('.CartItemWrapper');
          if(!elementWrapper && element.getAttribute('pfand-key'))
            elementWrapper = element;
          if(elementWrapper.getAttribute('pfand-key')){
            let correspondingPfand = document.querySelector('.pfand-item[pfand-key="'+elementWrapper.getAttribute('pfand-key')+'"]');
            if(correspondingPfand){
              MainSubscribedFunctionalityWithPFD(element, correspondingPfand.querySelector('.downgrade'));
            }
          }else{
            MainSubscribedFunctionality(element);
          }
        });
      });
    }

    function changeSellingPlanOfSubscribedProduct(){
      let sellingSet = document.querySelectorAll(".sellingSet");
      // console.log("sellingSet: ",sellingSet);
      sellingSet.forEach(element => {
        element.addEventListener('click', function(){
          if(!element.classList.contains('currentSellingPlan')){
            HideAllSelectedOptions();
            //check pfand 
            let elementWrapper = element.closest('.CartItem');
            if(!elementWrapper)
              elementWrapper = element.closest('.CartItemWrapper');
            if(elementWrapper.getAttribute('pfand-key')){
              let correspondingPfand = document.querySelector('.pfand-item[pfand-key="'+elementWrapper.getAttribute('pfand-key')+'"]');
              if(correspondingPfand){
                let planIndex = element.getAttribute('data-index');
                MainSubscribedFunctionalityWithPFD(element, correspondingPfand.querySelector('.sellingSet[data-index="'+planIndex+'"]'));
              }
            }else{
              MainSubscribedFunctionality(element);
            }
          }
        });
      });
    }

    function MainSubscribedFunctionality(mainElement){
      // console.log("mainElement: ",mainElement);
      let subscripedParentDiv = mainElement.closest('.newSubscribedEdits');
      if(subscripedParentDiv == null){
        subscripedParentDiv = mainElement.closest('.CartItem__Info');
      }
      // console.log("subscripedParentDiv: ",subscripedParentDiv);
      let subscriped_variantID = mainElement.getAttribute("data-variant-id");
      let subscriped_sellingId = mainElement.getAttribute("data-selling-id");
      let subscriped_qty = subscripedParentDiv.querySelector('.QuantitySelector__CurrentQuantity').value;
      let line_item_key = subscripedParentDiv.querySelector('.CartItem__Remove').getAttribute('data-key');

      removeItemFromCart2(line_item_key,subscriped_variantID,subscriped_qty,subscriped_sellingId);
    }

    function MainSubscribedFunctionalityWithPFD(mainElement, pfndElement){
      // console.log("mainElement: ",mainElement);
      let subscripedParentDiv = mainElement.closest('.newSubscribedEdits');
      if(subscripedParentDiv == null){
        subscripedParentDiv = mainElement.closest('.CartItem__Info');
      }
      // main
      let subscriped_variantID = mainElement.getAttribute("data-variant-id");
      let subscriped_sellingId = mainElement.getAttribute("data-selling-id");
      let subscriped_qty = subscripedParentDiv.querySelector('.QuantitySelector__CurrentQuantity').value;
      let line_item_key = subscripedParentDiv.querySelector('.CartItem__Remove').getAttribute('data-key');

      //pfand 
      let pfandWrapper = pfndElement.closest('.newSubscribedEdits');
      if(pfandWrapper == null){
        pfandWrapper = pfndElement.closest('.CartItem__Info');
      }
      let pfd_subscriped_variantID = pfndElement.getAttribute("data-variant-id");
      let pfd_subscriped_sellingId = pfndElement.getAttribute("data-selling-id");
      let pfd_subscriped_qty = pfandWrapper.querySelector('.QuantitySelector__CurrentQuantity').value;
      let pfd_line_item_key = pfandWrapper.querySelector('.CartItem__Remove').getAttribute('data-key');

      let removeItems ={};
      removeItems[line_item_key]=0;
      removeItems[pfd_line_item_key]=0;

      let pfandObject = {
        id: pfd_subscriped_variantID,
        quantity: pfd_subscriped_qty, 
        selling_plan: pfd_subscriped_sellingId,
        qty_multi: pfandWrapper.querySelector('.QuantitySelector__CurrentQuantity').getAttribute('pfand-key').split('-')[0]
      }
      removeItemFromCartWithPFD(removeItems,subscriped_variantID,subscriped_qty,subscriped_sellingId, pfandObject);

    }

});